
export default {
  selectEduCalendarCond: { // 교육캘린더 검색조건 조회
    method: 'POST',
    url: 'mrm/v1/anonym/nrw/educal/eduCalendarCond'
  },
  selectEduCalMonthlyList: { // 교육캘린더 월간교육일정 조회
    method: 'POST',
    url: 'mrm/v1/anonym/nrw/educal/monthlyList'
  },
  selectEduCalCourseList: { // 교육캘린더 과정 목록 조회
    method: 'POST',
    showSpinner: false, // 스피너 OFF
    url: 'mrm/v1/anonym/nrw/educal/courseList'
  },
  selectEduCalYearEduList: { // 교육캘린더 연간교육일정 조회
    method: 'POST',
    url: 'mrm/v1/anonym/nrw/educal/yearEduList'
  }
}



// WEBPACK FOOTER //
// ./src/config/router/nrw/api/eduCalApi.js